import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { motion } from "framer-motion";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function BlogIndexPage() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    axios.get(`${API}/blog`).then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <>
      <Navbar />
      <main data-testid="blog-index-page" className="pt-32 lg:pt-40 pb-24 bg-[#FAF9F6]">
        <div className="mx-auto max-w-7xl px-6 lg:px-12">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.28em] text-[#B35B47]">— The Journal</div>
            <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl mt-5 text-[#2C302E] leading-[1.02]">
              Notes from the<br />quiet path.
            </h1>
            <p className="mt-7 text-[#5C605A] text-lg leading-relaxed">
              Soft reflections on healing, energy work, and the slow art of
              coming home to yourself.
            </p>
          </div>

          <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.map((p, i) => (
              <motion.div
                key={p.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
              >
                <Link to={`/blog/${p.slug}`} className="group block" data-testid={`blog-list-card-${p.slug}`}>
                  <div className="aspect-[4/3] rounded-2xl overflow-hidden bg-[#EAE5D9]">
                    <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-105" />
                  </div>
                  <div className="mt-5 flex items-center gap-3 text-xs uppercase tracking-[0.2em] text-[#8A8D86]">
                    <span className="text-[#B35B47]">{p.tag}</span><span>·</span><span>{p.read_time}</span>
                  </div>
                  <h3 className="font-serif text-2xl lg:text-[1.7rem] mt-3 text-[#2C302E] group-hover:text-[#B35B47] transition-colors">{p.title}</h3>
                  <p className="mt-3 text-[#5C605A] line-clamp-3">{p.excerpt}</p>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
